import { Alert, Box, Button, MessageColor, MessageSize, Stack, SxProps, Theme, Typography, styled, useMediaQuery } from '@mui/material';
import * as React from 'react';
import { messageIcons } from './messageIcons';

export const MessageBox = ({
    color,
    size = 'small',
    title,
    children,
    buttonText,
    buttonAction,
    buttonComponent,
    showShadow,
    hideIcon,
    sx,
    buttonVariant,
}: {
    color: MessageColor;
    size?: MessageSize;
    title?: string;
    children?: React.ReactNode;
    buttonText?: string;
    buttonAction?: () => void;
    buttonComponent?: React.ReactNode;
    showShadow?: boolean;
    hideIcon?: boolean;
    sx?: SxProps;
    buttonVariant?: 'text' | 'outlined' | 'contained';
}) => {
    const isXSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
    const iconWithoutTitle = !title && !hideIcon;
    const iconWithoutTitleStyle = { margin: 'auto', paddingTop: '0.5em' };

    return (
        <StyledAlert
            size={size}
            sx={{ display: 'flex', alignItems: 'center', boxShadow: 'boxShadow', ...sx }}
            color={color}
            showShadow={showShadow}
            icon={false}
        >
            <Stack direction="row" spacing={1}>
                {!hideIcon && <div style={iconWithoutTitle ? iconWithoutTitleStyle : {}}>{messageIcons[color]}</div>}
                <Stack direction={isXSmall ? 'column' : 'row'} spacing={2}>
                    <Stack alignSelf="center" spacing={0.5}>
                        {title && (
                            <Typography color={color + '.main'} fontWeight="bold">
                                {title}
                            </Typography>
                        )}
                        {children}
                    </Stack>
                    <Box alignSelf={isXSmall ? 'start' : 'end'}>
                        {!buttonComponent && buttonText && (
                            <Button variant={buttonVariant || 'contained'} size="small" onClick={buttonAction} color={color as any}>
                                {buttonText}
                            </Button>
                        )}
                        {buttonComponent}
                    </Box>
                </Stack>
            </Stack>
        </StyledAlert>
    );
};

const StyledAlert = styled(Alert, { shouldForwardProp: (prop) => prop !== 'showShadow' })(({ theme, showShadow }) => ({
    boxShadow: showShadow ? theme.shape.shadow : 'none',
}));
